import { gql } from "@apollo/client";

export default gql`
  fragment AboutPageConfigFields on AboutPageConfig {
    _id
    config {
      headingText
      headingTextFontColor
      subtitleText
      subtitleTextFontColor
      bannerBackgroundSrc
      bannerBackgroundDescription
      bannerContentType
      bannerContentText
      bannerContentSize
      bannerContentDescription

      boxesSectionBackgroundColor
      leftButtonText
      leftButtonBackgroundColor
      leftButtonTextColor
      leftButtonHoverColor
      leftButtonBorderColor
      leftButtonHref

      rightButtonText
      rightButtonBackgroundColor
      rightButtonHoverColor
      rightButtonBorderColor
      rightButtonTextColor
      rightButtonHref

      leftBox {
        ... on TextSideContent {
          iconDescription
          iconSrc
          title
          titleFontColor
          text
          textFontColor
          textHref
          textHrefHoverColor
          width
          height
        }
        ... on CarouselSideContent {
          images {
            src
            alt
          }
          text
          textHref
          textHrefHoverColor
          buttonText
          buttonFontColor
          buttonBackgroundColor
          buttonHref
        }
      }
      rightBox {
        ... on TextSideContent {
          iconDescription
          iconSrc
          title
          titleFontColor
          text
          textFontColor
          textHref
          textHrefHoverColor
          width
          height
        }
        ... on CarouselSideContent {
          images {
            src
            alt
          }
          text
          textHref
          textHrefHoverColor
          buttonText
          buttonFontColor
          buttonBackgroundColor
          buttonHref
        }
      }

      videoSectionTitle
      videoSectionBackground
      videoSectionFontColor
      videoSectionContentType
      videoSectionContentText

      joinSectionBackground
      joinSectionTitle
      joinSectionTitleFontColor
      joinSectionSubtitle
      joinSectionSubtitleFontColor
      joinSectionButtonText
      joinSectionButtonHref
      joinSectionButtonColor
      joinSectionButtonFontColor

      logoSectionBackgroundColor
      logoUrls {
        imageUrl
        url
        description
      }
    }
  }
`;
